import React, { useState, useEffect } from "react";
import { MenuItem, FormControl, Select, Typography } from "@mui/material";
import { jwtDecode } from "jwt-decode";

export function Dropdown({
  selectedIds,
  setSelectedIds,
  setSelectedClass,
  selectedClass,
}) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [decodedToken, setDecodedToken] = useState(null);


  useEffect(() => {
    const token = localStorage.getItem('token');
    const queryParameters = new URLSearchParams(window.location.search);

    if (token!=queryParameters.get('jwt')) {
      // setIsReset(true);
      // setSelectedClass(-1);
      const decoded = jwtDecode(queryParameters.get('jwt'));
      setDecodedToken(decoded);
      // return;
    } else{
      const decoded = jwtDecode(token);
      setDecodedToken(decoded);
    }

  },[]);

  // Set the default value for selectedClass to "Toàn trường"
  // useEffect(() => {
  //   if (!selectedClass) {
  //     setSelectedClass({ id: "0", name: "Toàn trường" });
  //   }
  // }, [selectedClass, setSelectedClass]);

  // useEffect(() => {
  //   // Sample JWT token (you would normally get this from your authentication flow)
  //   const token = localStorage.getItem("token"); // Assuming token is stored in localStorage

  //   if (token) {
  //     const decoded = jwtDecode(token);
  //     setDecodedToken(decoded);
  //   }
  // }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const headers = { Authorization: `Bearer ${token}` };
      fetch("/api/v1/moet/classes", { headers })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          setSelectedClass(data[0]);
          setData(data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }, [setSelectedClass]);

  const handleChange = (event) => {
    const selectedId = event.target.value;
    const selectedClass =
      selectedId === 0
        ? { id: "0", name: "Toàn trường" }
        : data.find((item) => item.id === selectedId);

    setSelectedClass(selectedClass);
  };

  return (
    <FormControl size="small" fullWidth>
      { decodedToken?.lis_course_offering_sourcedid ? (
       <></>
      ) : (
        <>
          <Typography>Chọn lớp</Typography>
          <Select
            labelId="data-select-label"
            id="data-select"
            value={selectedClass?.id || 0} // Default to "Toàn trường" when no selection is made
            label="Select Data"
            onChange={handleChange}
          >
            {isLoading ? (
              <MenuItem key={-1} value={"Đang tải dữ liệu"} disabled>
                Đang tải dữ liệu
              </MenuItem>
            ) : (
              [
                ...data.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                )),
                <MenuItem key={0} value={0}>
                  Toàn trường
                </MenuItem>,
              ]
            )}
          </Select>
        </>
      )}
    </FormControl>
  );
}
